import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { UserService } from './_services/user.service';

import {
  AlertModule,
  ButtonsModule,
  IconModule,
  NavbarModule,
  TooltipModule,
  UtilsModule,
} from 'axis-components';
import { SkipNavigationModule } from 'axis-components/skip-nav';
import { TruncateModule } from 'axis-components/truncate';

import { filter } from 'rxjs/operators';
import { RequestService } from './_services/request/request.service';

@Component({
  imports: [
    ButtonsModule,
    CommonModule,
    IconModule,
    NavbarModule,
    SkipNavigationModule,
    TooltipModule,
    TruncateModule,
    UtilsModule,
    AlertModule,
    RouterModule,
  ],
  standalone: true,
  selector: 'app-navbar',
  templateUrl: './app-navbar.component.html',
})
export class AppNavbarComponent implements OnInit {
  @Input() title: string = '';
  showAlert = false;
  /* properties */
  screenSize: any;

  navbarOpen = false;

  // policyNumbers = '';
  // coveredStates = '';
  // liabilityLimit = '';
  // policyEffDate = '';
  // issuingCompany = '';

  policyNumber1 = '';
  policyNumber2 = '';

  policyDescription1 = '';
  policyDescription2 = '';

  coveredStates1 = '';
  coveredStates2 = '';
  liabilityLimit1 = '';
  liabilityLimit2 = '';
  policyEffDate1 = '';
  policyEffDate2 = '';
  issuingCompany1 = '';
  issuingCompany2 = '';

  requestKey: string | null = null;
  policyCount = 2;
  showPolicyDetails: boolean = true;
  isShowingGarageStates = false;

  private _request; // Typed input property to receive request details
  public get request() {
    return this._request;
  }
  @Input()
  public set request(value) {
    this._request = value;
    if (!value) {
      return;
    }
    let policyDetailArray = [];
    policyDetailArray = value?.requestDetails?.policyDetail;
   
   
    let policyNumbersAr = [];
    if (Array.isArray(policyDetailArray)) {
      policyNumbersAr = policyDetailArray.map((item: any) => item.number);
      this.policyCount = policyNumbersAr.length;
    }
    if (policyNumbersAr?.length === 1) {
      this.policyNumber1 = policyNumbersAr[0];      
    } else if (policyNumbersAr.length === 2) {
      this.policyNumber1 = policyNumbersAr[0];      
      this.policyNumber2 = policyNumbersAr[1];      
    }

    let policyDescAr = [];
    if (Array.isArray(policyDetailArray)) {
      policyDescAr = policyDetailArray.map((item: any) => item.policyDescription);
    }
   
    if (policyDescAr?.length === 1) {
      this.policyDescription1 = policyDescAr[0];      
    } else if (policyDescAr.length === 2) {
      this.policyDescription1 = policyDescAr[0];      
      this.policyDescription2 = policyDescAr[1];      
    }

    let coveredStatesAr = [];
    if (Array.isArray(policyDetailArray)) {
      // Check if garage states are available using the service method
      const hasGarageStates = this.requestService.hasGarageStates();

      if (hasGarageStates) {
        // Use garage states when available
        this.isShowingGarageStates = true;
        coveredStatesAr = policyDetailArray.map((item: any) =>
          Array.isArray(item.garageStates) && item.garageStates.length > 0
            ? item.garageStates.map((s: any) => s.value).join(', ')
            : '',
        );
      } else {
        // covered states
        this.isShowingGarageStates = false;
        coveredStatesAr = policyDetailArray.map((item: any) =>
          Array.isArray(item.coveredStates)
            ? item.coveredStates.map((s: any) => s.value).join(', ')
            : '',
        );
      }
    }

    if (coveredStatesAr?.length === 1) {
      this.coveredStates1 = coveredStatesAr[0];
    } else if (coveredStatesAr.length === 2) {
      this.coveredStates1 = coveredStatesAr[0];
      this.coveredStates2 = coveredStatesAr[1];
    }

    let liabilityLimitAr = [];
    if (Array.isArray(policyDetailArray)) {
      liabilityLimitAr = policyDetailArray.map((item: any) => item.liability);
    }
    // Format liability limits, handling both comma and non-comma numbers

   
    if (liabilityLimitAr.length === 1) {
      this.liabilityLimit1 = liabilityLimitAr[0];
    } else if (liabilityLimitAr.length === 2) {
      this.liabilityLimit1 = liabilityLimitAr[0];
      this.liabilityLimit2 = liabilityLimitAr[1];
    }

    let policyEffDateAr = [];
    if (Array.isArray(policyDetailArray)) {
      policyEffDateAr = policyDetailArray.map((item: any) =>
        this.formatDisplayDate(item.effectiveDate),
      );
    }

    if (policyEffDateAr.length === 1) {
      this.policyEffDate1 = policyEffDateAr[0];
    } else if (policyEffDateAr.length === 2) {
      this.policyEffDate1 = policyEffDateAr[0];
      this.policyEffDate2 = policyEffDateAr[1];
    }
   

    // just take the first issuing company.
    let issuingCompanyAr = [];
    if (Array.isArray(policyDetailArray)) {
      issuingCompanyAr = policyDetailArray.map(
        (item: any) => item.issuingCompany.name,
      );
    }
    if (issuingCompanyAr.length === 1) {
      this.issuingCompany1 = issuingCompanyAr[0];
    } else if (issuingCompanyAr.length === 2) {
      this.issuingCompany1 = issuingCompanyAr[0];
      this.issuingCompany2 = issuingCompanyAr[1];
    }
  }
  constructor(
    private breakpointObserver: BreakpointObserver,
    public renderer: Renderer2,
    public router: Router,
    public userService: UserService,
    private requestService: RequestService,
  ) {
    this.request = this.requestService.request;
    this.requestKey = this.requestService.getRequestKey();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showAlert = event.url === '/insured/uimui-consent';
      });
  }

  formatDisplayDate(dateStr: string): string {
    // Expects dateStr in 'YYYY-MM-DD' format
    if (!dateStr) {
      return '';
    }
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const [year, month, day] = dateStr.split('-');
    const mIdx = parseInt(month, 10) - 1;
    const d = parseInt(day, 10);
    if (isNaN(mIdx) || mIdx < 0 || mIdx > 11 || isNaN(d) || d < 1 || d > 31) {
      return dateStr;
    }
    return `${months[mIdx]} ${d}, ${year}`;
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 767px)'])
      .subscribe((state: BreakpointState) => {
        if (Object.values(state.breakpoints)[0]) {
          this.screenSize = 'mobile';
        } else {
          this.screenSize = 'desktop';
        }
        this.renderer.setAttribute(
          document.documentElement,
          'data-screensize',
          this.screenSize,
        );
      });
  }

  // doTask(): void {
  //   // behavior as needed
  // }

  /* methods */
  closeOverlay(): void {
    this.navbarOpen = false;
    this.renderer.removeClass(document.body, 'axis-navbar-mobile-open');
  }
}
